import React from 'react'
// @ts-ignore no types
import { CardContainer } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

interface KeyboardShortcutsGuideProps {
  isVisible?: boolean
}

const KeyboardShortcutsGuide: React.FC<KeyboardShortcutsGuideProps> = ({
  isVisible = true,
}) => {
  if (!isVisible) return null

  return (
    <CardContainer
      style={{ padding: '6px 12px 2px' }}
      padding='extra-small'
      className={cx('keyboard-shortcuts')}
    >
      <span className={cx('section')}>
        <span className={cx('category')}>NAV:</span>
        <kbd>▲</kbd>/<kbd>▼</kbd>
      </span>

      <span className={cx('separator')}>|</span>

      <span className={cx('section')}>
        <span className={cx('category')}>SAVE:</span>
        <kbd>Shift</kbd>+<kbd>Enter</kbd> Next
      </span>

      <span className={cx('separator')}>|</span>

      <span className={cx('section')}>
        <span className={cx('category')}>RATE:</span>
        <kbd>+</kbd>/<kbd>=</kbd> Up <kbd style={{ marginLeft: '6px' }}>-</kbd>/
        <kbd>_</kbd> Down
      </span>

      <span className={cx('separator')}>|</span>

      <span className={cx('section')}>
        <span className={cx('category')}>TRACE SCROLL:</span>
        <kbd>Shift</kbd>
        <kbd>▲</kbd>/<kbd>▼</kbd>
      </span>

      <span className={cx('separator')}>|</span>

      <span className={cx('section')}>
        <span className={cx('category')}>TOGGLE HELP:</span>
        <kbd>/</kbd>
      </span>
    </CardContainer>
  )
}

export default KeyboardShortcutsGuide
